import { render, staticRenderFns } from "./CatalogSuggestionItem.vue?vue&type=template&id=2fd10319&"
import script from "./CatalogSuggestionItem.vue?vue&type=script&lang=js&"
export * from "./CatalogSuggestionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports